<div class="reveal-overlay tpiq-reveal">
</div>
<div class="reveal tax-strategy-reveal tpiq-reveal"
     style="padding: 0; border: none; width: 50%;">
  <div style="height: 50px; padding: 15px; color: #333333;">
    <span class="float-left">Create/Select a Client</span>
    <span (click)="cancel()" class="float-right pointer">X</span>
  </div>
  <div style="padding: 0 15px;">
    <hr style="margin: 0;"/>
  </div>
  <div class="body d-flex flex-column new-input-fields" style="padding: 15px;height: calc(100vh - 175px)">
    <div #scrollContainer class="row tax-planning-client upload-client d-flex flex-fill min-h-0 overflow-auto">
      <div class="medium-12 columns mt-2">
        <div class="row">
          <div class="medium-2">
            <label style="position: relative;top: 6px;">Pick a Client</label>
          </div>
          <div class="medium-10">
            <label>
              <app-tpiq-select-dropdown (onValueSelect)="onClientSelect($event)" [includeNone]="false"
                                        [setData]="clientsList" [setDefaultValue]=""
                                        [setPlaceHolder]="'Pick a Client'" [setSearchKey]="'name'"
                                        [setValueKey]="'id'"></app-tpiq-select-dropdown>
            </label>
          </div>
        </div>
      </div>
      <div class="d-flex justify-content-center medium-12 mt-3 mb-2">
        <div style="font-size: 18px; color: #1570EF;">(OR)</div>
      </div>
      <div class="medium-12 columns">
        <label>
          Plan Name*
          <input [(ngModel)]="client.planName" placeholder="Plan Name" type="text"/>
        </label>
      </div>
      <div class="medium-6 columns">
        <label>
          First Name*
          <input (blur)="appendIndyRelatedParty()" [(ngModel)]="client.firstName" placeholder="First Name"
                 type="text"/>
        </label>
      </div>
      <div class="medium-6 columns">
        <label>
          Last Name*
          <input (blur)="appendIndyRelatedParty()" [(ngModel)]="client.lastName" placeholder="Last Name" type="text"/>
        </label>
      </div>
      <!-- <div class="medium-6 columns">
        <label>
          Filing Status
          <app-tpiq-select-dropdown (onValueSelect)="onFilingSelect($event)" [includeNone]="false"
                                    [setData]="filingStatusList" [setDefaultValue]="client.filingStatus" [setPlaceHolder]="'Filing Status'"
                                    [setSearchKey]="'name'"
                                    [setValueKey]="'name'"></app-tpiq-select-dropdown>
        </label>
      </div> -->
      <!-- <div class="medium-6 columns">
        <label>
          Plan Year
          <app-tpiq-select-dropdown (onValueSelect)="setYear($event, 'planYear')" [includeNone]="false"
                                    [setData]="years"
                                    [setDefaultValue]="client.defaultYear || ''" [setPlaceHolder]="'Plan Year'"
                                    [setSearchKey]="'name'" [setValueKey]="'id'"></app-tpiq-select-dropdown>
        </label>
      </div> -->

      <div class="medium-12 columns mt-4" style="background: rgba(234, 236, 240, 0.5);border-radius: 4px;">
        <div *ngFor="let relatedParty of client.relatedParties; let index = index;" class="row"
             style="padding-top: 5px">
          <div class="medium-5 columns">
            <label>Related Party*
              <input [(ngModel)]="relatedParty.name" placeholder="Related Party" type="text"/>
            </label>
          </div>
          <div class="medium-5 columns">
            <label>Type
              <app-tpiq-select-dropdown (onValueSelect)="setType($event, relatedParty)" [includeNone]="false"
                                        [setData]="types"
                                        [setDefaultValue]="relatedParty.type" [setPlaceHolder]="'Type'"
                                        [setSearchKey]="'name'" [setValueKey]="'name'"></app-tpiq-select-dropdown>
            </label>
          </div>
          <div class="medium-2 columns">
            <i (click)="removeRelatedParty(index)" class="material-icons delete-icon"
               style="position: relative;top: 25px;">delete</i>
          </div>
        </div>
        <div style="padding: 10px 0;">
          <span (click)="addRelatedParty()" class="pointer badge-tooltip">
            <i class="material-icons float-left add-icon">add_circle_outline</i>
            <span class="float-left add-text">Related Party</span>
            <span class="topTooltiptext related-parties-tooltip">
              Related parties can be any existing or potential businesses or related individuals to your client
            </span>
          </span>
        </div>
      </div>

      <div *ngIf="uploader && uploader.queue.length > 0" class="medium-12 columns mt-3">
        <div class="mb-3">
          <label>Uploaded Document</label>
        </div>
        <div class="d-flex flex-wrap">
          <div *ngFor="let item of uploader.queue; let i=index;" class="tp-file-item-box">
            <div class="file-font" title="{{item.file.name}}">
              <div class="tp-file-item-name">{{item.file.name}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="mt-4 flex-shrink-0">
      <button class="button small float-right" (click)="uploadFile()">Upload</button>
      <button class="button small float-right" style="border: 1px solid #D0D5DD;border-radius: 6px;background: #FFFFFF;color:#333333;" (click)="cancel()">Cancel</button>
    </div>
  </div>
</div>

